import React from 'react';
import { logo } from '../../../../assets/images';
import Image from 'next/image';
const NavLogo = ({ height = '' }: { height?: string }) => {
  return (
    <>
      <Image
        className={`h-[24px] w-[74px] ${height}`}
        src={logo.src}
        alt="logo"
        width={500}
        height={500}
        // priority
        fetchPriority="high"
        loading="eager"
        quality={65}
        sizes="(max-width: 640px) 100px, (max-width: 1024px) 120px, 160px"
      />
    </>
  );
};

export default NavLogo;
